import { PocketBaseClient } from "./PocketbaseClient.js";

export const fetchPlaylist = async ({ recordName, playlistId }) => {
  console.log("FETCHING PLAYLIST", recordName, playlistId);
  if (!recordName || !playlistId) {
    throw new Error("recordName and playlistId are required");
  }
  if (!!recordName && recordName === "user_playlists") {
    return await PocketBaseClient.collection(recordName).getOne(playlistId, {
      expand: "songs",
    });
  }
  return await PocketBaseClient.collection("playlists").getOne(playlistId, {
    expand: "songs",
  });
};
